export { default } from './StylesProvider';
export * from './StylesProvider';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/StylesProvider/index.js
// module id = 238
// module chunks = 0